import { getAccountStore } from '../storage/stores';

export const getAccountUidIfConfigured = (): string | undefined => {
  const accountData = getAccountStore().get();
  if (!accountData) {
    return;
  }

  return accountData.accountUid;
};
